import { Injectable } from '@angular/core';
import { ConfirmDialogTextKeyModel } from '@commonInterfaces/ConfirmDialogTextKeyModel';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: "root"
})
export class ConfirmDialogService {

	constructor() { }
	public modalAlreadyOpen = false;
	private subject = new Subject<any>();
	public open(textKeyModel: ConfirmDialogTextKeyModel, confirmEventHandler?: any, dismissEventHandler?: any, backdropClose?: boolean, closeButton?: boolean) {
		this.subject.next(
			{
				textKeyModel,
				confirmEventHandler,
				dismissEventHandler,
				backdropClose,
				closeButton
			}
		);
	}

	public getConfirmDialog(): Observable<any> {
		return this.subject.asObservable();
	}
}
